import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Form, Button, Alert } from 'react-bootstrap'
import axios from "axios";
import '../styles/FormRecoverUser.css';

export default function FormRecoverUser(){ 
    const navigate = useNavigate();
    const location = useLocation();
    const recoverAccount = location.state?.recoverAccount;
   
    useEffect(() => {
        document.title = "Recover Account"; // Set the tab name
        
        // if (!recoverAccount) {
        //     navigate('/forgot/find', { replace: true });
        // }
    }, []);

    const [errorRecover, setErrorRecover] = useState({
        type: "",
        message: ""
    }); 

    const [input_data, setInputs] = useState({});
 
    const changeValues = (event) =>
        {
            const { name, value } = event.target;
            setInputs
            (
                (oldInputs) =>
                ({
                    ...oldInputs,
                    [name] : value
                })
            );
        };

        const attempt_recover = (event) =>
            {
                event.preventDefault();
                
                if (recoverAccount && input_data.recover_password_1 === input_data.recover_password_2)
                    { 
                    axios.patch('https://docuquest-swu.swucite.tech/api_drts/recoverAccount.php', 
                      {email:recoverAccount, finalPassword:input_data.recover_password_2},
                      {headers: { "Content-Type": "application/json" }
                    })
                    .then((res)=>{
                        if (res.data.status == 1) {
                            // TODO pass object to login.js
                            // axios.post('https://docuquest-swu.swucite.tech/api_drts/loginUser.php', {
                            //     // data
                            //     email: recoverAccount,
                            //     password: input_data.recover_password_2
                            // },
                            // {
                            //     withCredentials: true
                            // })
                            // .then((responseUser) => {
                            //     if(responseUser.data.status === 1){
                            //         sessionStorage.setItem("name_user", responseUser.data.name);
                            //         sessionStorage.setItem("id_user", responseUser.data.id);
                            //         sessionStorage.setItem("role_user", responseUser.data.role);
                            //         navigate('/*');
                            //     }
                            // })
                            // .catch((err) => {
                            //     console.error("ERROR LOGIN STAFF: ", err);

                            // });
                            navigate('/login');
                        } else {
                          setErrorRecover({
                            type:"danger",
                            message:`${res.data.status}: ${res.data.message}`
                          })
                        }
                    })
                    .catch((err)=>{
                        setErrorRecover({
                            type:"danger",
                            message:`cannot login with new password: ${err}`
                          })      
                    })
                    }

            };
        
    return (
        <section className="form-recover">
          <div className="container-4">
            {recoverAccount ? (
                <>
                <h2 className="mb-4">Reset Password</h2>
                <h5>{recoverAccount}</h5>
                </>
            ) : (
                <h2 className="mb-4">No account to recover. Please start over.</h2>
            )}
            {errorRecover ? (
                <Alert variant={errorRecover.type}>
                    {errorRecover.message}
                </Alert>
            ) : ""
            }
            <Form onSubmit={attempt_recover}>
                <Form.Group>
                    <Form.Label htmlFor="recover_password_1">Enter your new password</Form.Label>
                    <Form.Control required name="recover_password_1" type="password" onChange={changeValues} placeholder="New password" />
                </Form.Group>
                <Form.Group>
                    <Form.Label htmlFor="recover_password_2">Confirm your new password</Form.Label>
                    <Form.Control required name="recover_password_2" type="password" onChange={changeValues} placeholder="Confirm new password" />
                </Form.Group>
                <Form.Group className="mt-3">
                    <Button as="input" type="submit" value={'Reset Password & Login'} />
                </Form.Group>
            </Form>
          </div>
        </section>

    )
}